import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=6930c5ec&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"
import style0 from "./Access.vue?vue&type=style&index=0&id=6930c5ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.5_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template-_ar323sprjn4ukbaqn3gh4itclu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930c5ec",
  null
  
)

export default component.exports